import { lazy } from "react";

import { importRemote } from "@module-federation/utilities";
import { MicroFrontendLoader } from "@moodys/mdc-frontend.helpers.micro-frontend-loader";
import { getMFEBasePath } from "@moodys/mdc-shared-runtime";
import {
  Box,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useHeaderContext } from "components/Header/context";
import { MoodysThemeProviderWhitney } from "components/MoodysThemeProviderWhitney";
import { isCreditRatingsPage, isCv1Page } from "utils/page";

import { CopilotIcon } from "./CopilotIcon/CopilotIcon";
import { styles } from "./ResearchAssistant.styles";

const ResearchAssistantRemote = lazy(() =>
  importRemote({
    url: getMFEBasePath({
      path: "mfe/genai",
      staticStructure: true,
    }),
    scope: "MdcChat",
    module: "GenAIChat",
    bustRemoteEntryCache: false,
  })
);

const ResearchAssistantRemoteInLegacy = lazy(() =>
  importRemote({
    url: getMFEBasePath({
      path: "mfe/genai/external-react",
      staticStructure: true,
    }),
    scope: "MdcChat",
    module: "GenAIChat",
    bustRemoteEntryCache: false,
  })
);

export const ResearchAssistant = () => {
  const { isLegacy } = useHeaderContext();
  const isCv1 = isCv1Page();
  const isCreditRatings = isCreditRatingsPage();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));

  const renderResearchAssistant = () => {
    if (isDesktop) {
      return (
        <Box css={styles.buttonBackground(theme)}>
          <Button
            css={styles.button(theme)}
            size="large"
            startIcon={<CopilotIcon />}
          >
            <Typography
              component={"span"}
              css={styles.buttonText(theme)}
              variant="body2"
            >
              Research Assistant
            </Typography>
          </Button>
        </Box>
      );
    } else {
      return (
        <IconButton css={styles.iconButton(theme)}>
          <CopilotIcon />
        </IconButton>
      );
    }
  };

  const renderResearchAssistantComponent = () => {
    if (isLegacy && isCv1 && isCreditRatings) {
      return null;
    }

    const RemoteComponent = isLegacy
      ? ResearchAssistantRemoteInLegacy
      : ResearchAssistantRemote;

    return (
      <MoodysThemeProviderWhitney>
        <RemoteComponent>{renderResearchAssistant()}</RemoteComponent>
      </MoodysThemeProviderWhitney>
    );
  };

  return (
    <MicroFrontendLoader renderOnIntersect={false}>
      {renderResearchAssistantComponent()}
    </MicroFrontendLoader>
  );
};
